import React from 'react';

import {PublicStatusScreen} from 'features/statusPage';

const PublicStatusPage: React.FC = () => {
    return <PublicStatusScreen/>;
};

export default PublicStatusPage;
